import { BASEPATH } from "../../../utils/constants/constants";

export const EMAIL_RESPONSE_URL = {
  GET_NOTIFICATION_LOGS: `${BASEPATH}/downloads/download-notification-logs`,
}